define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var lpEngagementHistoryController = require('web-agent-assets-js/lpEngagementHistoryController');
    var lpSdeDataHandler = require('web-agent-assets-js/lpSdeDataHandler');

    lpTag.lpEngagementsHistoryTableController = function (model) {

        var timeNow = new Date().getTime();
        var defaultTimeRange = 604800000; // 7 days

        var defaultSearch = {
            query: {
                offset: 0,
                limit: 50,
                sort: "start:desc"
            },
            body: {
                interactive: true,
                ended: true,
                start: {
                    from: timeNow - defaultTimeRange,
                    to: "Now" // This value represents to the service that we want the most recent results
                }
            }
        };

        var controllerConfig = {
            applicationType: "lpEngagementsHistoryTableController",
            model: model,
            modelPath: "engagementsHistory",
            defaultSearchParameters: defaultSearch,
            modifyDataCallback: getEngagementsObject,
            supportOperatorAndSkillNames: true,
            pollOnTimeIsNow: true
        };

        var engagementsHistoryTableController = new lpEngagementHistoryController(controllerConfig);
        return engagementsHistoryTableController;

//////////////////// private methods /////////////////////////

        function getEngagementsObject(engagementsArray) {
            var engagementsObject = {};
            for (var i = 0; i < engagementsArray.length; i++) {
                engagementsHistoryTableController.modifyEngagementObject(engagementsArray[i]);
                var singleEngagementObject = getSingleEngagementObject(engagementsArray[i]);
                engagementsObject[engagementsArray[i].info.engagementId] = singleEngagementObject;
                engagementsArray[i].participantInfo = engagementsArray[i].info;
                delete engagementsArray[i].info;
                delete engagementsArray[i].transcript;
            }
            return engagementsObject;
        }

        function getSingleEngagementObject(engagementObject) {
            var propertyName;
            var toReturn = {
                chatInfo : {
                    chatId : engagementObject.info.engagementId,
                    skillId : engagementObject.info.skillId,
                    skillName : engagementObject.info.skillName,
                    endTime : engagementObject.info.endTimeL,
                    startTime : engagementObject.info.startTimeL,
                    events : {
                        event : engagementObject.transcript.lines
                    },
                    mcs : engagementObject.info.mcs,
                    messageRawScore : engagementObject.info.messageRawScore,
                    startPage : engagementObject.info.chatStartPage,
                    startUrl : engagementObject.info.chatStartUrl
                },
                agentInfo : {
                    agentId : engagementObject.info.agentId,
                    agentName : engagementObject.info.agentName,
                    agentNickname : engagementObject.info.agentNickname
                },
                visitorInfo : {
                    visitorName : engagementObject.info.visitorName
                }
            };
            if (engagementObject.info.agentDeleted) {
                toReturn.agentInfo.agentDeleted = engagementObject.info.agentDeleted;
                _.forEach(toReturn.chatInfo.events.event, function (line) {
                    if (engagementObject.info.agentId == line.agentId) {
                        line.agentDeleted = true;
                    }
                });
            }
            if (engagementObject.visitorInfo) {
                toReturn.chatInfo.device = engagementObject.visitorInfo.device;
            }
            toReturn.data = {};
            if(engagementObject.surveys){
                toReturn.data =  {
                    preChat : engagementObject.surveys.preChat,
                    postChat :  engagementObject.surveys.postChat,
                    agentSurvey : engagementObject.surveys.operator
                };

            _.forEach(toReturn.data, function(surveyArray) {
                    if(surveyArray) {
                        for (var i = 0; i < surveyArray.length; i++) {
                            surveyArray[i].value = surveyArray[i].values && surveyArray[i].values.join("; ");
                        }
                    }
                });
            }if (engagementObject.sdes) { //Inside this ask the monitoring functions
                lpSdeDataHandler.handleEvents(engagementObject.sdes.events, toReturn.data);
            }
            if (engagementObject.info.engagementId) {
                toReturn.data.engagementId = processEngagementForDisplay(engagementObject.info.engagementId);
            }
            if (engagementObject.info) {
                toReturn.data.visitorName = engagementObject.info.visitorName;
                toReturn.data.skill = engagementObject.info.skillName;
                lpUtils.setValue2object(toReturn,"data.externalReferrer", engagementObject.info.chatStartUrl);
            }
            if (engagementObject.visitorInfo) {
                for (propertyName in engagementObject.visitorInfo) { // We need to change some of the properties name to be like lpBaseInfoController (createCommonInfoDataObject) so the template will know them.
                    if (engagementObject.visitorInfo.hasOwnProperty(propertyName) && engagementObject.visitorInfo[propertyName]) {
                        switch (propertyName) {
                            case 'device':
                                toReturn.data.deviceFamily = engagementObject.visitorInfo.device;
                                break;
                            case 'city':
                                toReturn.data.geoCity = engagementObject.visitorInfo.city;
                                break;
                            case 'org':
                                toReturn.data.organization = engagementObject.visitorInfo.org;
                                break;
                            case 'isp':
                                toReturn.data.geoISP = engagementObject.visitorInfo.isp;
                                break;
                            case 'browser':
                                lpUtils.setValue2object(toReturn,"data.browser", engagementObject.visitorInfo.browser);
                                break;
                            case 'ipAddress':
                            case 'ip':
                                toReturn.data.ipv4 = engagementObject.visitorInfo.ipAddress;
                                break;
                            default:
                                toReturn.data[propertyName] = engagementObject.visitorInfo[propertyName];
                                break;
                        }
                    }
                }
            }
            if (engagementObject.campaign) {
                if (!toReturn.data.campaign){
                    toReturn.data.campaign = {};
                }
                for (propertyName in engagementObject.campaign) { // We need to change some of the properties name to be like lpBaseInfoController (createCommonInfoDataObject) so the template will know them.
                    if (engagementObject.campaign.hasOwnProperty(propertyName) && engagementObject.campaign[propertyName]) {
                        switch (propertyName) {
                            case "campaignName":
                                lpUtils.setValue2object(toReturn,"data.campaign.name", engagementObject.campaign[propertyName]);
                                break;
                            case "goalName":
                                lpUtils.setValue2object(toReturn,"data.goal.name", engagementObject.campaign[propertyName]);
                                break;
                            case "visitorProfileName":
                                lpUtils.setValue2object(toReturn,"data.visitorProfile.name", engagementObject.campaign[propertyName]);
                                break;
                            case "visitorBehaviorName":
                                lpUtils.setValue2object(toReturn,"data.visitorBehavior.name", engagementObject.campaign.behaviorSystemDefault ? agentLEManager.translateLE('LEWebAgent.visitorBehavior.default.name') : engagementObject.campaign[propertyName]);
                                break;
                            case "campaignEngagementName":
                                lpUtils.setValue2object(toReturn,"data.engagement.name", engagementObject.campaign[propertyName]);
                                break;
                            case "lobName":if (engagementObject.campaign.lobId !== -1) {
                                lpUtils.setValue2object(toReturn,"data.lob.name", engagementObject.campaign[propertyName]);
                                }
                                break;
                            case "engagementAgentNote":
                                lpUtils.setValue2object(toReturn, "data.engagement.agentNote",engagementObject.campaign[propertyName]);
                                break;
                            default:
                                break;
                        }
                    }
                }
            }

            return toReturn;
        }

        function processEngagementForDisplay(rawEngagementId) {
            return rawEngagementId.replace(LE.loginInfo.accountId, '').split("-")[0];
        }
    };

    return lpTag.lpEngagementsHistoryTableController;

});
